import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { FacebookService, GqlFilterErrorService } from '@core/services';
import { AynNgbModalRef, Facebook } from '@core/models';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { forkJoin, Observable, race } from 'rxjs';
import { catchError, filter, finalize, switchMap } from 'rxjs/operators';
import { ApolloError } from '@apollo/client/errors';
import { HttpErrorResponse } from '@angular/common/http';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { InstagramAccountValidateComponent } from '@shared/components/account-select-modal/platforms/facebook/instagram-account-select/instagram-account-validate.component';

@UntilDestroy()
@Component({
  selector: 'aayn-ad-preview--facebook',
  templateUrl: './ad-preview.component.html'
})
export class AdPreviewFacebookComponent implements OnInit {
  @Input() selectedAdType: Facebook.AdType = Facebook.AdType.DynamicCreative;

  protected AdTypes = Facebook.AdType;

  protected businessPageDetail?: Facebook.IBusinessPageDetail;
  protected instagramPageDetail?: Facebook.FacebookInstagramAccountOutput;

  constructor(
    private facebookService: FacebookService,
    private cdr: ChangeDetectorRef,
    private modalService: NgbModal,
    private filterErrorService: GqlFilterErrorService
  ) {}

  ngOnInit(): void {
    forkJoin({
      businessPageDetail: this.facebookService.getBusinessPageDetail$(),
      instagramPageDetail: this.businessInstagramUserDetail$()
    })
      .pipe(untilDestroyed(this))
      .subscribe((result) => {
        this.businessPageDetail = result.businessPageDetail?.data?.businessPageDetail;
        this.instagramPageDetail = result.instagramPageDetail?.data?.businessInstagramUserDetail;
        this.cdr.detectChanges();
      });
  }

  businessInstagramUserDetail$() {
    this.filterErrorService.registerFilterError('BusinessInstagramUserDetail', (error) => {
      return (
        error instanceof HttpErrorResponse &&
        error.error.message.includes(Facebook.PLATFORM_ERRORS.INSTAGRAM_LEGACY_OBJECT)
      );
    });
    return this.facebookService.businessInstagramUserDetail$().pipe(
      catchError((error: ApolloError) => {
        if (
          error.cause instanceof HttpErrorResponse &&
          error.cause?.error.message.includes(Facebook.PLATFORM_ERRORS.INSTAGRAM_LEGACY_OBJECT)
        ) {
          return this.openNeedUpdateModal().pipe(
            filter((result) => !!result),
            switchMap(() => this.facebookService.businessInstagramUserDetail$())
          );
        }
        throw error;
      }),
      finalize(() => this.filterErrorService.unregisterFilterError('BusinessInstagramUserDetail'))
    );
  }

  openNeedUpdateModal() {
    return new Observable((observer) => {
      const modalRef = this.modalService.open(InstagramAccountValidateComponent, {
        backdrop: 'static',
        keyboard: false
      }) as AynNgbModalRef<InstagramAccountValidateComponent>;

      modalRef.componentInstance.confirmButton.subscribe(() => {
        observer.next(true);
        observer.complete();
      });

      race(modalRef.componentInstance.cancelButton, modalRef.closed.pipe(filter((result) => !result))).subscribe(() => {
        observer.next(false);
        observer.complete();
      });
    });
  }
}
